import { useContext, useState } from 'react';
import { List, ListItemButton, ListItemText } from '@mui/material';
import { Menu, MenuItem } from '@mui/material';
import { localeManagerContext } from 'helpers/Locale';
import { FlagIcon } from 'components';
import { useIntl } from 'react-intl';


let LocaleMenu = () => {
    let { formatMessage } = useIntl()

    let localeManager = useContext(localeManagerContext);

    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    let handleOpen = (e: any) => {
        setAnchorEl(e.currentTarget);
    }

    let chooseLocale = (locale?: string) => async () => {
        if (locale)
            localeManager.updateCurrentLocale(locale);

        setAnchorEl(null);
    }

    return (
        <>
            <List component="nav" disablePadding>
                <ListItemButton id="locale-menu" onClick={handleOpen}>
                    <ListItemText
                        style={{ whiteSpace: 'nowrap' }}
                        primary={
                            <strong style={{ textTransform: 'uppercase' }}>
                                <FlagIcon locale={localeManager.currentLocale} />&nbsp;{formatMessage({ id: localeManager.locales.getValueByKey(localeManager.currentLocale) })}
                            </strong>
                        }
                    />
                </ListItemButton>
            </List>

            <Menu
                keepMounted
                anchorEl={anchorEl}
                open={anchorEl !== null}
                onClose={() => setAnchorEl(null)}
            >
                {localeManager.locales.map(locale =>
                    <MenuItem
                        key={locale.key}
                        onClick={chooseLocale(locale.key)}
                        selected={localeManager.currentLocale === locale.key}
                    >
                        <FlagIcon locale={locale.key} />&nbsp;&nbsp;{locale.value}
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}

export default LocaleMenu;